import { Injectable, Injector } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { Message } from '../classes/message';
import { Observable } from 'rxjs';
import { io } from 'socket.io-client';
import { UsersService } from './users.service';
import { UserGroup, User } from '../classes/user';
import { catchError , retry } from 'rxjs/internal/operators';
import { HttpHeaders,HttpClient } from '@angular/common/http';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { GlobalSearchService } from './globalsearchservice.service';
import { GlobalsService } from './globals.service';
import { RuntimeConfigLoaderService } from 'runtime-config-loader';

@Injectable({
	providedIn: 'root'
})
export class SocketService {
	key = 'UET6DFMPAXW7BKCB';
	config: any;
	//todo make connection reusabel
	socket: any;
	details: any;
	user : any = [];
	environment = {
		production: false,
		SOCKET_ENDPOINT: 'wss://socket.clevehilltire.com:5009',
		user: '',
	};

	public httpOptions = {
		headers: new HttpHeaders({
			'Content-Type':	'application/json',
		})
	};

	constructor(private globalsService: GlobalsService,private http: HttpClient,private _configSvc: RuntimeConfigLoaderService, private injector: Injector) {

		this.config = this._configSvc.getConfig()
		if(this.config) {

			if(this.globalsService.user) {
				this.user = this.globalsService.user.user;
			}

			this.environment.SOCKET_ENDPOINT = this.config.apiServer.socket;
		}

		// Use Injector to lazily get GlobalSearchService to avoid circular dependency
		// Subscribe to config changes to update socket connection
		setTimeout(() => {
			try {
				const globalSearchService = this.injector.get(GlobalSearchService);
				globalSearchService.configsubscription.subscribe((newConfig: any) => {
					if (newConfig && newConfig.apiServer && newConfig.apiServer.socket) {
						const newSocketEndpoint = newConfig.apiServer.socket;
						
						// Only reconnect if the endpoint actually changed
						if (this.environment.SOCKET_ENDPOINT !== newSocketEndpoint) {
							this.config = newConfig;
							this.environment.SOCKET_ENDPOINT = newSocketEndpoint;
							
							// Disconnect existing socket if it exists
							if (this.socket) {
								this.socket.disconnect();
								this.socket = null;
							}
							
							// If socket was already set up, reconnect with new endpoint
							if (this.user && this.user.userid) {
								this.setupSocketConnection(this.user.userid);
							}
						}
					}
				});
			} catch (error) {
				console.warn('Could not subscribe to config changes:', error);
			}
		}, 0);
		//this.environment.user = this.globalsService.user
		//user.userid;
	}

	setupSocketConnection(token: string) {

		if(!this.socket) {
			if(!this.user){
				token = this.randomString(12, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
			} else {
				token = this.user.userid;
			}

			this.socket = io(this.environment.SOCKET_ENDPOINT, {
				auth: { token },
				reconnection: true,
				reconnectionAttempts: 5,
				reconnectionDelay: 1000
			});

			this.socket.connected ? '' : this.socket.connect();


		} else {
			// If socket exists but endpoint changed, disconnect and reconnect
			if (this.socket.io && this.socket.io.uri !== this.environment.SOCKET_ENDPOINT) {
				this.socket.disconnect();
				this.socket = null;
				this.setupSocketConnection(token);
			}
		}
	}

	subscribeToGroupUpdate = (cb) => {

		if(!this.socket) {
			const token = this.randomString(12, '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ');
			this.setupSocketConnection(token)
		}

		// Wait for connection before joining room
		if (this.socket.connected) {
			this.joinRoom('Users');
		} else {
			this.socket.on('connect', () => {
				this.joinRoom('Users');
			});
		}

		this.socket.on('updategroup', msg => {
			console.log('Received updategroup broadcast:', msg);
			return cb(null, msg);
		});
	}

	sendUserGroupUpdate= ({ data, roomName }, cb) => {
		if(!this.socket) {
			this.setupSocketConnection(this.user.userid)
		}

		if (this.socket && this.socket.connected) {
			this.socket.emit('usergroupupdate', { data , roomName }, cb);
		} else {
			console.warn('Socket not connected - permission update will not be broadcast');
			if (cb) cb({ status: 'error', message: 'Socket not connected' });
		}
	}

	joinRoom = (roomName) => {
		this.socket.emit('join', roomName);
	}

	disconnect() {
		if (this.socket) {
			this.socket.disconnect();
			this.socket.connect();
		}
	}
	//interal updates
	public getUserUpdate(user: any) {
		this.user = user;
		const method = 'users/getuserbyid';
		return this.http.post(this.setEndPoint(method), user, this.httpOptions).pipe(
			catchError(this.handleError('users', user))
		);
	}

	private getApi() {
		  return this.config.apiServer.crossPoint;
	}

	private getApiKey() {
		return '&key='+this.config.apiCredentials.clientId+'&userid='+this.user.user.userid;
	}

	public getKey() {
		  return '&apikey='+this.key+'&userid='+this.user.user.userid;
	}

	private getPackage() {
		const p = sessionStorage.getItem('app')
		if(p) {
			return '&package='+p;
		} else {
			return '';
		}
	}


	private setEndPoint(method: any) {
		  return this.getApi()+method+this.getApiKey()+this.getPackage()
	}

	private handleError<T>(operation = 'operation', result?: T) {
		return (error: any): Observable<T> => {

			return error;
		};
	}

	randomString(length: any, chars: any) {
		let result = '';
		for (let i = length; i > 0; --i) {result += chars[Math.floor(Math.random() * chars.length)];}
		return result;
	}
}
